const PrescriptionIcon: React.FC<{ color?: string }> = ({ color = '#222C69' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.7781 4.22209C22.1211 6.56509 22.1211 10.3641 19.7781 12.7071L17.6561 14.8271L12.7071 19.7781C10.3641 22.1211 6.56509 22.1211 4.22209 19.7781C1.87909 17.4351 1.87909 13.6361 4.22209 11.2931L11.2921 4.22209C13.6361 1.87909 17.4351 1.87909 19.7781 4.22209ZM14.8281 14.8281L9.17209 9.17209L5.63609 12.7071C4.07409 14.2691 4.07409 16.8021 5.63609 18.3641C7.19809 19.9261 9.73109 19.9261 11.2931 18.3641L14.8281 14.8281Z"
        fill={color} />
    </svg>

  )
}
export default PrescriptionIcon